module.exports = __webpack_public_path__ + "static/img/zfb.4c07cf1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zfb.png
// module id = CN0g
// module chunks = 1